import useReveal from '@/hooks/useReveal';

const contactDetails = [
  { label: 'Address', value: 'Mihkli' },
  { label: 'City', value: 'Arase kula' },
  { label: 'Zip', value: '87206' },
  { label: 'Country', value: 'Estonia' },
  { label: 'Phone number', value: '+372 59122362' },
  { label: 'Email', value: 'ceo@gahnoosystems.com' },
];

export default function ContactSection() {
  const { ref, visible } = useReveal();

  return (
    <section className="relative w-full bg-background-200 overflow-hidden">
      <div className="absolute top-0 left-0 w-[200px] h-[40px] bg-foreground-900/90 rounded-lg rotate-12 -translate-x-16 -translate-y-4" />
      <div className="absolute bottom-0 right-0 w-[200px] h-[40px] bg-foreground-900/90 rounded-lg rotate-12 translate-x-16 translate-y-4" />

      <div
        ref={ref}
        className={`reveal ${visible ? 'visible' : ''} relative w-full max-w-[1280px] mx-auto flex flex-col lg:flex-row py-24 md:py-28 lg:py-[100px] px-6 md:px-10 lg:px-20 gap-10 lg:gap-0`}
      >
        <div className="w-full lg:w-[30%]">
          <h2 className="font-body text-[40px] sm:text-[48px] md:text-[56px] font-bold leading-[1.05] text-foreground-950">
            Contact
          </h2>
        </div>

        <div className="w-full lg:w-[70%] flex flex-col gap-8 md:gap-10">
          {contactDetails.map((item) => (
            <div key={item.label}>
              <p className="text-[10px] font-body font-medium uppercase tracking-[0.2em] text-foreground-500 mb-1">
                {item.label}
              </p>
              <p className="text-[15px] sm:text-[16px] md:text-[17px] font-body font-medium text-foreground-950">
                {item.value}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}